export var Routes = {
    HOMEPAGE: '/',
    CART: '/sepetim',
    DELIVERY_ADDRESS: '/teslimat-adresi',
    MEMBERSHIP_LOGIN: '/uye-girisi',
    ADDITIONAL_PRODUCTS: '/ek-urunler',
    CARD_MESSAGE: '/kart-mesaji',
    INVOICE_INFORMATION: '/fatura-bilgileri'
};
